export const helpDrawerUrl = 'https://helpcenter.labra.io/hc/en-us'

export const keysWithCostToDecimnal = [
  'grossAmount',
  'grossRefund',
  'listingFee',
  'listingFeeRefund',
  'sellerTaxShare',
  'sellerTaxRefund',
  'awsTaxShare',
  'awsTaxShareRefund',
  'awsTaxShareListingFee',
  'awsTaxShareRefundListingFee',
  'wholeSaleCost',
  'wholeSaleCostRefund',
  'sellerNetRevenue',
  'grossRevenue',
  'wholesaleSellerTaxShare',
  'wholesaleSellerTaxShareRefund',
  'wholesaleOtherSellerTaxShare',
  'wholesaleOtherSellerTaxShareRefund',
  'wholesaleAwsTaxShare',
  'wholesaleAwsTaxShareRefund',
  'disbursedNetRevenue',
  'undisbursedNetRevenue',
  'collectedNetRevenue',
  'uncollectedNetRevenue',
]

export const keysWithPercentageToDisplay = ['listingFeePercentage']

export { customDateRanges } from './meteringConstants'
